import { z } from "zod";
//#region src/payment/discount.ts
const PaymentDiscountType = {
	PERCENTAGE: "PERCENTAGE",
	FIXED_MICROS: "FIXED_MICROS"
};
const PaymentDiscountTypes = Object.values(PaymentDiscountType);
const paymentDiscountTypeSchema = z.enum(PaymentDiscountTypes);
//#endregion
export { PaymentDiscountType, paymentDiscountTypeSchema };
